export enum E_Routes {
  HOME = 'home',
  LOGIN = 'login',
  FAQ = 'faq',
  PROFILE = 'profile',
  EDIT_PROFILE = 'profile/edit',
  PROFILE_POOLS = 'profile/pools',
  POOLS_PRESALE = 'pools-presale/',
  TERMS_AND_CONDITIONS = 'terms-and-conditions',
  PRIVACY_POLICY = 'privacy-policy',
  POOLS = 'pools/',
  PROFILE_POOL_BTC = 'profile/pools/btc',
  PROFILE_REFERRALS = 'profile/referrals',
  PROFILE_PREDICTIONS = 'profile/predictions'
}
